import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 5.8.",
  "description": "",
  "published": "2011-08-06T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-5/swizec/2087"],
  "categories": "Learning, Nola, Palo Alto, Palo Alto California, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`![Photograph of Palo Alto City Hall.]`}{`(`}{` "Photograph of Palo Alto City Hall.")`}</p>
    <p>{`Today I learned that `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{` really really sucks for `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Party",
        "title": "Party"
      }}>{`partying`}</a>{`. I know this isn't the first time I have learned this and that after being stuck in the house for a whole week doing nothing but starting at the screen and producing coloured pixels roughly shaped into instructions a computer might understand as orders ... it's almost better than nothing.`}</p>
    <p>{`It's not that the whole thing is inherently bad. There's two whole bars you can go partying in!`}</p>
    <p>{`But there just isn't enough choice and the atmosphere in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=40.9333333333,14.5333333333&spn=1.0,1.0&q=40.9333333333,14.5333333333%20(Nola)&t=h",
        "title": "Nola"
      }}>{`Nola`}</a>{`'s and The Old Pro just simply isn't my thing. The music kind of sucks, there are too many people cramped into a single space and there is no dancing. When I have to endure a crowd, I want the crowd to at least be dancing to cool music.`}</p>
    <p>{`Another thing that I learned is that I am a far far cry from a professional writer still. Writing things on demand simply doesn't work for me, or maybe today was a specially bad day for that ... it's really difficult to tell with these creative things when you're just not good enough to produce on demand and when you just simply need some inspiration, increasing the entropy in your life and so on.`}</p>
    <p>{`Should work on that.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/going-from-slovenia-to-palo-alto-what-culture-shock/swizec/1947"
        }}>{`Going from Slovenia to Palo Alto ... what culture shock?`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-29-7/swizec/2022"
        }}>{`I learned two things today 29.7.`}</a>{` (swizec.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d1bee4c3-f88d-4912-820d-01fc66207d83",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      